import React from 'react';

import FareRules from './FareRules/FareRules';

const fareInfo = (props) => {
    return (
        <div className={`u-minHeight80 u-relative pt-4 pb-4`}>
                <div className={`u-height100Percent u-width100Percent`}>
                    <FareRules rules={props.fareRules} isIntFlight={props.isIntFlight} />
                </div>
        </div>
    );
}

export default fareInfo;


// WEBPACK FOOTER //
// ./src/components/Flight/Tuple/TupleInner/FareInfo/FareInfo.js